module.exports = __webpack_public_path__ + "img/login-bg.95936ace.png";